interface Props {
  label?: string | undefined
  unit?: string | undefined
  value: number
  onChange: (value: number) => void
  min?: number | undefined
  max?: number | undefined
  /** 'any' を渡すと小数を受け付ける。単位の決まっていない指標で使う。 */
  step?: number | 'any' | undefined
  error?: string | undefined
  ariaLabel?: string | undefined
}

/**
 * 数値入力。
 *
 * 空文字や途中入力を NaN として親に渡し、バリデーションは呼び出し側に任せる。
 * 入力途中に値を勝手に補正すると、タイプしている最中に桁が飛んで操作できない。
 *
 * 要素の構造は error や label の有無で変えない。エラーの出現でラッパーの
 * 種類が変わると React が input を作り直し、値を消した瞬間にフォーカスが
 * 外れて続けて入力できなくなる。
 */
export function NumberField({
  label,
  unit,
  value,
  onChange,
  min,
  max,
  step,
  error,
  ariaLabel,
}: Props) {
  return (
    <div className="field">
      {label ? (
        <label className="field-label">
          {label} {unit && <span className="field-unit">{unit}</span>}
        </label>
      ) : null}
      <input
        type="number"
        value={Number.isFinite(value) ? value : ''}
        min={min}
        max={max}
        step={step}
        aria-label={ariaLabel ?? label}
        aria-invalid={error ? true : undefined}
        onChange={(event) => {
          const raw = event.target.value
          onChange(raw === '' ? NaN : Number(raw))
        }}
      />
      {error ? <span className="field-error">{error}</span> : null}
    </div>
  )
}
